import { create } from "zustand";
import { STAGE } from "./constants";

const stage = STAGE.LOGIN;

export const useAuthModalStore = create((set, get) => ({
  open:
    typeof window !== "undefined" && window.localStorage
      ? !JSON.parse(localStorage.getItem("SIGNED_IN"))
      : false,
  setOpen: (open) => set({ open }),
  stage,
  setStage: (stage) => set({ stage }),
}));

export default useAuthModalStore;
